import { AccountPublic } from '@pollination-solutions/pollination-sdk'
import { useAuth } from 'auth-context'
import { useEffect, useState } from 'react'

const useBillingFeatureFlag = (account: AccountPublic) => {
  const [useNewBillingAPI, setUseNewBillingAPI] = useState(false)
  const { user } = useAuth()

  useEffect(() => {
    const isUserInBetaGroup = user?.email?.includes('ladybug.tools')
    setUseNewBillingAPI(Boolean(isUserInBetaGroup))
  }, [user, account])

  return { useNewBillingAPI }
}

export default useBillingFeatureFlag